<app-accordion-item [index]="0" [showBody]="showFeatures()" [highlightStyle]="'dark'" [highlightInsetX]="-16" [highlightInsetY]="-4" class="margin-bottom-lg">
  <ng-container ngProjectAs="[accHeader]">
    <p class="menu-title" [class.text-grey-60]="showFeatures()">
      {{ 'MOBILE_MENU.FEATURES' | translate }}
    </p>
  </ng-container>

  <div class="features-list">
    <div class="feature-list-title">{{ 'MOBILE_MENU.BASIC_FEATURES' | translate }}</div>

    <div class="feature" [touchRouterLink]="localeService.getLink(routesEnum.ACCOUNTING)" [routerLinkActive]="'text-grey-60'">
      <app-icon [icon]="foldersIcon"></app-icon>
      <p class="feature-title">{{ 'MOBILE_MENU.ACCOUNTING_TITLE' | translate }}</p>
      <p class="feature-description">{{ 'MOBILE_MENU.ACCOUNTING_DESC' | translate }}</p>
    </div>

    <div class="feature" [touchRouterLink]="localeService.getLink(routesEnum.SALES)" [routerLinkActive]="'text-grey-60'">
      <app-icon [icon]="moneyIcon"></app-icon>
      <p class="feature-title">{{ 'MOBILE_MENU.SALES_TITLE' | translate }}</p>
      <p class="feature-description">{{ 'MOBILE_MENU.SALES_DESC' | translate }}</p>
    </div>

    <div class="feature" [touchRouterLink]="localeService.getLink(routesEnum.PRODUCTS)" [routerLinkActive]="'text-grey-60'">
      <app-icon [icon]="deliveryIcon"></app-icon>
      <p class="feature-title">{{ 'MOBILE_MENU.PRODUCTS_TITLE' | translate }}</p>
      <p class="feature-description">{{ 'MOBILE_MENU.PRODUCTS_DESC' | translate }}</p>
    </div>

    <div class="feature" [touchRouterLink]="localeService.getLink(routesEnum.PARTNERS)" [routerLinkActive]="'text-grey-60'">
      <app-icon [icon]="heartIcon"></app-icon>
      <p class="feature-title">{{ 'MOBILE_MENU.PARTNERS_TITLE' | translate }}</p>
      <p class="feature-description">{{ 'MOBILE_MENU.PARTNERS_DESC' | translate }}</p>
    </div>

    <div class="feature" [touchRouterLink]="localeService.getLink(routesEnum.TEAM)" [routerLinkActive]="'text-grey-60'">
      <app-icon [icon]="teamIcon"></app-icon>
      <p class="feature-title">{{ 'MOBILE_MENU.TEAM_TITLE' | translate }}</p>
      <p class="feature-description">{{ 'MOBILE_MENU.TEAM_DESC' | translate }}</p>
    </div>

    <div class="feature-list-title">{{ 'MOBILE_MENU.EXT_FEATURES' | translate }}</div>

    <div class="feature" [touchRouterLink]="localeService.getLink(routesEnum.INVENTORY_MANAGEMENT)" [routerLinkActive]="'text-grey-60'">
      <app-icon [icon]="warehouseIcon"></app-icon>
      <p class="feature-title">{{ 'MOBILE_MENU.INVENTORY_TITLE' | translate }}</p>
      <p class="feature-description">{{ 'MOBILE_MENU.INVENTORY_DESC' | translate }}</p>
    </div>

    <div class="feature" [touchRouterLink]="localeService.getLink(routesEnum.TIME_TRACKING)" [routerLinkActive]="'text-grey-60'">
      <app-icon [icon]="stopwatchIcon"></app-icon>
      <p class="feature-title">{{ 'HEADER_V2.TIME_TRACKING_TITLE' | translate }}</p>
      <p class="feature-description">{{ 'HEADER_V2.TIME_TRACKING_DESC' | translate }}</p>
    </div>
  </div>
</app-accordion-item>

<app-accordion-item [index]="1" [showBody]="showExtensions()" [highlightStyle]="'dark'" [highlightInsetX]="-16" [highlightInsetY]="-4" class="margin-bottom-lg">
  <ng-container ngProjectAs="[accHeader]">
    <p class="menu-title" [class.text-grey-60]="showExtensions()">
      {{ 'MOBILE_MENU.EXTENSIONS' | translate }}
    </p>
  </ng-container>

  <div class="features-list">
    <div class="feature lg" [touchRouterLink]="localeService.getLink(routesEnum.INVENTORY_MANAGEMENT)" [routerLinkActive]="'text-grey-60'">
      <app-icon class="icon-lg" [icon]="warehouseSquareIcon"></app-icon>
      <p class="feature-title">{{ 'MOBILE_MENU.INVENTORY_TITLE' | translate }}</p>
      <p class="feature-description">{{ 'MOBILE_MENU.INVENTORY_DESC_SHORT' | translate }}</p>
    </div>

    <div class="feature lg" [touchRouterLink]="localeService.getLink(routesEnum.SERVICES)" [routerLinkActive]="'text-grey-60'">
      <app-icon class="icon-lg" [icon]="servicesSquareIcon"></app-icon>
      <p class="feature-title">{{ 'MOBILE_MENU.SERVICES_TITLE' | translate }}</p>
      <p class="feature-description">{{ 'MOBILE_MENU.SERVICES_DESC' | translate }}</p>
    </div>

    <div class="feature lg" [touchRouterLink]="localeService.getLink(routesEnum.RETAIL)" [routerLinkActive]="'text-grey-60'">
      <app-icon class="icon-lg" [icon]="mobileSquareIcon"></app-icon>
      <p class="feature-title">{{ 'MOBILE_MENU.RETAIL_TITLE' | translate }}</p>
      <p class="feature-description">{{ 'MOBILE_MENU.RETAIL_DESC' | translate }}</p>
    </div>

    <div class="feature lg" [touchRouterLink]="localeService.getLink(routesEnum.ECOMMERCE)" [routerLinkActive]="'text-grey-60'">
      <app-icon class="icon-lg" [icon]="ecommerceSquareIcon"></app-icon>
      <p class="feature-title">{{ 'MOBILE_MENU.ECOMMERCE_TITLE' | translate }}</p>
      <p class="feature-description">{{ 'MOBILE_MENU.ECOMMERCE_DESC' | translate }}</p>
    </div>
  </div>
</app-accordion-item>

<p class="menu-title no-accordion margin-bottom-lg"
  buttonTap
  [highlightStyle]="'dark'"
  [highlightInsetX]="-16" [highlightInsetY]="-4"
  [touchRouterLink]="localeService.getLink(routesEnum.PRICING)"
  [routerLinkActive]="'text-grey-60'">
  <span class="label">{{ 'MOBILE_MENU.PRICES' | translate }}</span>
</p>

<p class="menu-title no-accordion margin-bottom-lg"
  buttonTap
  [highlightStyle]="'dark'"
  [highlightInsetX]="-16" [highlightInsetY]="-4"
  [touchRouterLink]="localeService.getLink(routesEnum.ABOUT)"
  [routerLinkActive]="'text-grey-60'">
  <span class="label">{{ 'MOBILE_MENU.ABOUT' | translate }}</span>
</p>

<div class="apps">
  <a href="https://apps.apple.com/app/runple/id6742907148" target="_blank" touchHover rel="nofollow noopener">
      <img src="assets/images/home/app-store.svg" alt="Download on the App Store" />
      <img class="li" src="assets/images/home/app-store-light.svg" alt="Download on the App Store" />
  </a>
  <a href="https://play.google.com/store/apps/details?id=com.runple.mobile" touchHover target="_blank" rel="nofollow noopener">
      <img src="assets/images/home/play-store.svg" alt="Get it on Google Play" />
      <img class="li" src="assets/images/home/play-store-light.svg" alt="Get it on Google Play" />
  </a>
</div>
